import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ApplicationDataService } from 'src/app/services/application-data.service';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { NotificationService } from 'src/app/services/notification-service';
import { ReportService } from 'src/app/services/report.service';

interface HistoryRecord {
  type: string;
  debitOrderDate: string;
  date: string;
  status: string;
  count: number;
  processed: string;
}

@Component({
  selector: 'app-suspension-process-history',
  templateUrl: './suspension-process-history.component.html',
  styleUrls: ['./suspension-process-history.component.scss']
})
export class SuspensionProcessHistoryComponent implements OnInit {
  historyData: any[] = [];
  dataSource: MatTableDataSource<HistoryRecord> = new MatTableDataSource<HistoryRecord>([]);
  displayedColumns: string[] = ['type', 'debitOrderDate', 'processed', 'count', 'scheduledBy', 'status', 'report'];
  @ViewChild(MatPaginator) paginator: MatPaginator;

  totalRecords = 0;
  pageNumber = 1;
  pageSize = 20;

  debitDates: any[] = [];
  statusList: any[] = [];
  filterForm: FormGroup;

  constructor(
    private applicationDataService: ApplicationDataService,
    private fb: FormBuilder,
    private lookUpDataService: LookupDataServiceService,
    private reportService: ReportService,
    private toastr: NotificationService
  ) {
    this.filterForm = this.fb.group({
      startDate: [null],
      endDate: [null],
      processType: [],
      debitOrderDate: [''],
      status: ['']
    });

    this.lookUpDataService.getDebitRunDateType(true).subscribe((res: any) => {
      this.debitDates = res;
    });

    this.lookUpDataService.getSuspensionProcessStatusType(true).subscribe((res: any) => {
      this.statusList = res;
    });

    this.getSuspensionHistoryList();
  }

  ngOnInit(): void { }

  getSuspensionHistoryList() {
    const payload =
    {
      pageNumber: this.pageNumber,
      pageSize: this.pageSize
    }
    this.applicationDataService.getSuspensionHistoryList(payload).subscribe(
      (result) => {
        this.totalRecords = result.details.length;
        this.historyData = result.details;
        this.dataSource.data = this.historyData;

        if (this.dataSource.paginator && this.pageNumber === 1) {
          this.dataSource.paginator.firstPage();
        }
      }
    );
  }

  applyFilter(): void {
    const formValues = this.filterForm.value;

    const noFiltersChosen = Object.values(formValues).every(v => v === null || v === '' || v === undefined);
    if (noFiltersChosen) {
      this.toastr.showWarning("Please select search query");
      return;
    }
    const payload = {
      filterQuery: {
        debitDateType: formValues.debitOrderDate !== null && formValues.debitOrderDate !== '' ? formValues.debitOrderDate : null,
        startDate: formValues.startDate ? new Date(formValues.startDate).toISOString() : null,
        endDate: formValues.endDate ? new Date(formValues.endDate).toISOString() : null,
        processStatusType: formValues.status || 0,
        processType: formValues.processType,
        // pageNumber: this.pageNumber,
        // pageSize: this.pageSize
      },
      pagination:
      {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize
      }
    };

    this.applicationDataService.getFilteredSuspensionHistoryList(payload).subscribe(
      (result) => {
        this.totalRecords = result.totalCount;
        this.historyData = result.details;
        this.dataSource.data = this.historyData;
        if (this.dataSource.paginator && this.pageNumber === 1) {
          this.dataSource.paginator.firstPage();
        }
      }
    );
  }

  onPageChange(event: any) {
    this.pageNumber = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    const formValues = this.filterForm.value;
    const noFiltersChosen = Object.values(formValues).every(v => v === null || v === '' || v === undefined);
    if (noFiltersChosen) {
      this.getSuspensionHistoryList();
    }
    else {
      this.applyFilter();
    }
  }

  // get filteredData(): HistoryRecord[] {
  //   return this.dataSource.data;
  // }

  getTypeStyles(type: string) {
    if (type.includes('Pre-')) return { color: '#c07a00', 'font-weight': '600' };
    if (type.includes('Post-')) return { color: '#0f7a60', 'font-weight': '600' };
    return { color: '#3a006f', 'font-weight': '600' };
  }

  download(data) {
    this.reportService.downloadSuspensionReport(data).subscribe((result) => {
      if (result != null) {
        const linkSource = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + result;
        const downloadLink = document.createElement('a');
        const fileName = data.processType === 5 ? 'Pre-Notification_Report.xlsx' : 'Suspension_Process_Report.xlsx';
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      } else {
        this.toastr.showError("No Data Available");
      }
    });
  }

  refresh() {
    this.filterForm.reset({
      startDate: null,
      endDate: null,
      processType: '',
      debitOrderDate: '',
      status: ''
    });

    this.pageNumber = 1;
    this.pageSize = 20;

    if (this.paginator) {
      this.paginator.firstPage();
    }
    this.getSuspensionHistoryList();
  }
}
